import * as tslib_1 from "tslib";
import { Hierarchy } from './hierarchy';
var TreeView = /** @class */ (function (_super) {
    tslib_1.__extends(TreeView, _super);
    function TreeView(param) {
        return _super.call(this, param) || this;
    }
    TreeView.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TreeView" });
    };
    TreeView.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TreeView;
}(Hierarchy));
export { TreeView };
//# sourceMappingURL=tree_view.js.map